// 作業員フォーム（#3433）: 会社を変えたら、その会社の取引部門を取り直して部門の select に入れる。
(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const select = document.querySelector('select[data-worker-business-unit]');
    const company = document.getElementById('worker_company_id');
    if (!select || !company) return;

    const reload = async () => {
      const companyId = company.value;
      select.innerHTML = '<option value=""></option>';
      if (!companyId) return;
      try {
        const response = await fetch(`${select.dataset.candidatesUrl}?company_id=${encodeURIComponent(companyId)}`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        });
        if (!response.ok) return;
        const units = await response.json();
        units.forEach((unit) => {
          const option = document.createElement('option');
          option.value = unit.id;
          option.textContent = unit.name;
          select.appendChild(option);
        });
      } catch (e) {
        // 取得失敗時は空のまま（保存時にサーバ側で必須エラー）
      }
    };

    // select2 は自分が載っている webpack 側の jQuery（ProvidePlugin の $）でしか change を発火しない。
    // window.jQuery（レイアウトの /jquery.min.js）や addEventListener では拾えない（#3433）
    $(company).on('change', reload);
  });
})();
